/**
 * P3-PROPOSAL — Barlow Condensed Bold CID->GID map (auto-generated from the
 * barlowcond-700-subset.ttf; DO NOT EDIT). F4 title face, 2026-10-22.
 */
export const BARLOW_COND_GIDS: Record<string, Record<string, number>> = {
  "bold": {
    "32": 3,
    "33": 100,
    "34": 115,
    "35": 103,
    "36": 118,
    "37": 126,
    "38": 128,
    "39": 116,
    "40": 106,
    "41": 107,
    "42": 102,
    "43": 119,
    "44": 97,
    "45": 112,
    "46": 96,
    "47": 104,
    "48": 65,
    "49": 66,
    "50": 67,
    "51": 68,
    "52": 69,
    "53": 70,
    "54": 71,
    "55": 72,
    "56": 73,
    "57": 74,
    "58": 98,
    "59": 99,
    "60": 123,
    "61": 121,
    "62": 122,
    "63": 101,
    "64": 127,
    "65": 4,
    "66": 5,
    "67": 6,
    "68": 7,
    "69": 8,
    "70": 9,
    "71": 10,
    "72": 11,
    "73": 12,
    "74": 13,
    "75": 14,
    "76": 15,
    "77": 16,
    "78": 17,
    "79": 18,
    "80": 19,
    "81": 20,
    "82": 21,
    "83": 22,
    "84": 23,
    "85": 24,
    "86": 25,
    "87": 26,
    "88": 27,
    "89": 28,
    "90": 29,
    "91": 110,
    "92": 105,
    "93": 111,
    "94": 125,
    "95": 114,
    "96": 132,
    "97": 30,
    "98": 31,
    "99": 32,
    "100": 33,
    "101": 34,
    "102": 35,
    "103": 36,
    "104": 37,
    "105": 38,
    "106": 41,
    "107": 42,
    "108": 43,
    "109": 44,
    "110": 45,
    "111": 46,
    "112": 47,
    "113": 48,
    "114": 49,
    "115": 50,
    "116": 51,
    "117": 52,
    "118": 53,
    "119": 54,
    "120": 55,
    "121": 56,
    "122": 57,
    "123": 108,
    "124": 129,
    "125": 109,
    "126": 124
  },
};
